import { render, staticRenderFns } from "./Project-404.vue?vue&type=template&id=3126b8bc&scoped=true"
import script from "./Project-404.vue?vue&type=script&lang=js"
export * from "./Project-404.vue?vue&type=script&lang=js"
import style0 from "./Project-404.vue?vue&type=style&index=0&id=3126b8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126b8bc",
  null
  
)

export default component.exports